import React from "react";
import {RegionalPartner} from "../Interfaces/RegionalPartner";
import i18n from "../i18n/config";

type Props ={
    buckets: RegionalPartner[]
    filter: string
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

class CheckboxFilter extends React.Component<Props, any> {
    render() {
        return (
            <div className={"filter"}>
                <label className={"filter-title"}>{i18n.t(this.props.filter)}</label>
                <div className={"checkbox-row"}>
                    {this.props.buckets.map((item:any, index:number) => (
                        <div className={"checkbox"} key={index}>
                            <label>
                                <input
                                    checked={item.selected}
                                    className="checkbox"
                                    value={item.key}
                                    data-filter={this.props.filter}
                                    type="checkbox"
                                    onChange={this.props.onChange}
                                    key={index}
                                />
                                <div className={"check-value"}>{item.key} ({item.doc_count})</div>
                                <div className={"checkmark"}></div>
                            </label>
                        </div>
                    ))}
                </div>
            </div>
        )
    }
}

export default CheckboxFilter
